// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: gt12.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "taf";
function createBaseGT12() {
    return {};
}
export const GT12 = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGT12();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return GT12.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGT12();
        return message;
    },
};
function createBaseGT12_Schedule() {
    return { programStart: 0, adBreaks: [] };
}
export const GT12_Schedule = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.programStart !== 0) {
            writer.uint32(8).int32(message.programStart);
        }
        for (const v of message.adBreaks) {
            GT12_Schedule_AdBreak.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGT12_Schedule();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.programStart = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.adBreaks.push(GT12_Schedule_AdBreak.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            programStart: isSet(object.programStart) ? globalThis.Number(object.programStart) : 0,
            adBreaks: globalThis.Array.isArray(object?.adBreaks)
                ? object.adBreaks.map((e) => GT12_Schedule_AdBreak.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.programStart !== 0) {
            obj.programStart = Math.round(message.programStart);
        }
        if (message.adBreaks?.length) {
            obj.adBreaks = message.adBreaks.map((e) => GT12_Schedule_AdBreak.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return GT12_Schedule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGT12_Schedule();
        message.programStart = object.programStart ?? 0;
        message.adBreaks = object.adBreaks?.map((e) => GT12_Schedule_AdBreak.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGT12_Schedule_AdBreak() {
    return { start: 0, adsEnd: undefined, promoStart: undefined, end: 0 };
}
export const GT12_Schedule_AdBreak = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.start !== 0) {
            writer.uint32(8).int32(message.start);
        }
        if (message.adsEnd !== undefined) {
            writer.uint32(16).int32(message.adsEnd);
        }
        if (message.promoStart !== undefined) {
            writer.uint32(24).int32(message.promoStart);
        }
        if (message.end !== 0) {
            writer.uint32(32).int32(message.end);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGT12_Schedule_AdBreak();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.start = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.adsEnd = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.promoStart = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.end = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            start: isSet(object.start) ? globalThis.Number(object.start) : 0,
            adsEnd: isSet(object.adsEnd) ? globalThis.Number(object.adsEnd) : undefined,
            promoStart: isSet(object.promoStart) ? globalThis.Number(object.promoStart) : undefined,
            end: isSet(object.end) ? globalThis.Number(object.end) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.start !== 0) {
            obj.start = Math.round(message.start);
        }
        if (message.adsEnd !== undefined) {
            obj.adsEnd = Math.round(message.adsEnd);
        }
        if (message.promoStart !== undefined) {
            obj.promoStart = Math.round(message.promoStart);
        }
        if (message.end !== 0) {
            obj.end = Math.round(message.end);
        }
        return obj;
    },
    create(base) {
        return GT12_Schedule_AdBreak.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGT12_Schedule_AdBreak();
        message.start = object.start ?? 0;
        message.adsEnd = object.adsEnd ?? undefined;
        message.promoStart = object.promoStart ?? undefined;
        message.end = object.end ?? 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
